import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class SPBLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="St. Pete Beach, FL" />
        <LocationMicroNav />

        <LocationContent 
          category="Promoting ridership" 
          title="See the World on Two Wheels"
          story="The annual National Bicycle Tourism Conference, sponsored by PeopleForBikes, brings together event promoters, tourism business owners, and city/government people involved in bike tourism and recreational bike events. PeopleForBikes gave a 30-minute presentation about our organization’s priorities and talked about the PlacesForBikes and our new Bicycle Network Analysis (BNA) tool. The BNA garnered a great deal of interest from a diverse set of stakeholders, from touring operators to the Active Transportation Alliance. From our perspective, bike tourism inspires people to bike, encourages all types of riding and provides major economic benefits to communities across the nation."
        />  
        <Img
          title="StPeteBeach"
          alt="National Bicycle Tourism Conference"
          sizes= { this.props.data.spbImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Arlington, VA"
          prevLocationPath="arlington"
          prevLocationImgPath= { this.props.data.spbPrevImage }
          nextLocationName="Wichita"
          nextLocationPath="wichita"
          nextLocationImgPath= { this.props.data.spbNextImage }
        /> 
      </div>
    )
  }
}

export default SPBLocation

// GraphQL query
export const SPBImageQuery = graphql`
  query SPBImageQuery {
    spbImage: imageSharp(id: { regex: "/PFB_StPeteBeach/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    spbPrevImage: imageSharp(id: { regex: "/PFB_ARLINGTON/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    spbNextImage: imageSharp(id: { regex: "/PFB_WICHITA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/st-pete-beach.js